export default {"src":"/login-app/[GIT_HASH]/_next/static/media/file_csv.5ab3cd26.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};